
const errorsActions = {
    addError: error => ({
        type: 'COMMON/ERRORS/ADD_ERROR',
        payload: {
            error
        }
    })
};

export default errorsActions;



// WEBPACK FOOTER //
// ./src/actions/errorsActions.js